var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Roblox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M24.49,28.73l-5.92-1.5l0.78-3.06l0.64-2.54l0.08-0.32L11.01,6.08l-2.26,8.89l-2.46,9.69 L3.34,36.29l30.21,7.67L24.49,28.73z M14.45,4.04l9.06,15.23l5.92,1.5l-0.78,3.06l-0.64,2.54l-0.08,0.32l9.06,15.23l2.26-8.89 l2.46-9.69l2.95-11.63L14.45,4.04z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Roblox);
export default __webpack_public_path__ + "static/media/icons8-roblox.c87149e1d8bf0dd21c62f94d64686500.svg";
export { ForwardRef as ReactComponent };